import { AUTH_API_BASE_URL, IBaseModel } from '../../shared';
import { AuthClient } from '../../shared/clients/auth.client';
import { IRole } from '../models';

class RoleClient extends AuthClient<IBaseModel, IRole> {
    constructor() {
        super(`${AUTH_API_BASE_URL}/v1/roles`);
    }
}

export const roleClient = new RoleClient();
